import logo from './assets/logo.png';
import large from './assets/large.png';
import small from './assets/small.png';
import apple from './assets/apple.png';
import share from './assets/share.png';

import googleplay from './assets/googleplay.png';
import 'typeface-Roboto-Medium';
import './App.css';
import airbridge from 'airbridge-web-sdk-loader'
import {useEffect,useState} from "react";

function App() {
    const [data, setData] = useState(null);
    const [downloadUrl, setDownloadUrl] = useState("https://shk4aj.hnhufm.com/android/XRVOD3U-vilive-1.0.2.apk");
    const [isLoading, setIsLoading] = useState(false);
    // const [error, setError] = useState(null);
    // const screenWidth = window.innerWidth;
    // console.log("width:",screenWidth);
    const getPlatform=()=> {
        const platform = navigator.platform.toLowerCase();
        if (platform.includes('win')) return 'android';
        if (platform.includes('mac')) return 'ios';
        if (platform.includes('linux')) return 'android';
        if (platform.includes('iphone')) return 'ios';
        //默认下载android
        return 'android';
    }
    const fetchData = async (platform) => {
        // setIsLoading(true);
        if(!isLoading) {
            setIsLoading(true);
        let domain=window.location.protocol+"//"+window.location.hostname;
        console.log("domain:",domain);
        if(domain.indexOf("127.0.0.1")||domain.indexOf("localhost"))
            domain='https://www.ano999.com';
        let url=domain+'/gateway-api/sys/api/app/anon/XRVOD3U/4c008a14f1794613b47da544969d3523';
        // url='http://app-vi.sunlove.shop/sstboot/sys/api/app/anon/sdfd/dsdssd';
        console.log("配置接口:",url);
        let returnObjectKey='result';
        let finalOptions={
            headers:{
                'Content-Type': 'application/json',
                'terminal':platform,
            }
        };
        // try {
        //     const response = await fetch('http://app-vi.sunlove.shop/sstboot/sys/api/app/anon/sdfd/dsdssd');
        //     const data = await response.json();
        //     console.log("data:",data);
        //     setData(data);
        // } catch (err) {
        //     setError(err.message);
        // } finally {
        //     setIsLoading(false);
        // }

            fetch(url, finalOptions)
                .then((response) => response.json())
                .then((data) => {
                    if (data.code == 200 || (data.code == 0 && data.success)) {
                        // console.log("请求结果:",data[returnObjectKey]);
                        setData(data[returnObjectKey]);
                    } else {
                        console.log("data=", data);
                    }
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.error('Request Error:', error);
                    setIsLoading(false);
                });
        }
    };
    useEffect(()=>{
        if(data) {
            let download=data.domains.RESOURCE[0].protocol+"://"+data.domains.RESOURCE[0].domain+data.version.download;
            if(getPlatform()=='ios')
            {
                download=data.version.superSign;
            }
            console.log("下载地址:", download);
            setDownloadUrl(download);

        }
    },[data]);
    const focusDownload=()=>{
        // alert(downloadUrl);
    }
    const download=()=>{
       console.log("airbridge:",airbridge.isSDKEnabled);
        // airbridge.setUserID('ab180')
        // airbridge.setUserEmail('user@example.com')
        airbridge.events.send('Download')
        window.fbq('track', 'Download'); //
        // let url="https://shk4aj.hnhufm.com/android/XRVOD3U-vilive-1.0.1.apk";
        // // url='http://192.168.8.114/android/XRVOD3U-vilive-1.0.1.apk';
        // const eleLink = document.createElement('a');
        // eleLink.style.display = 'none';
        // eleLink.target = "_blank"
        // eleLink.href = url;
        // // eleLink.href = record;
        // document.body.appendChild(eleLink);
        // eleLink.click();
        // document.body.removeChild(eleLink);
    }
    useEffect(()=>{
        airbridge.init({
            app: '69sport',
            webToken: 'c1cb225806ca499493eb37844522e68a',
        })
        let os=getPlatform();
        if(os=='ios')
            setDownloadUrl('https://nzzky.junjiamuye.com/wyS3q3AuAP/mzgxmdy3nm');
        if(data==null)
        {
            fetchData(os);
        }
        if(window.fbq){
            window.fbq('track','ViewContent');
            console.log('Facebook Pixel script is loaded.');
        }else
        {
            console.error('Facebook Pixel script is not loaded.');
        }
    },[]);
    return (
        <div className="container">
            <div className="c1">
                <div className="header-layout-01">
                    <img src={logo} className="header-logo" alt={""}/>
                </div>
                <div className="header-layout-02">
                    <p className="menu-01">
                        <label className="menu-text">Tải app</label>
                    </p>
                </div>
            </div>
            <div className="c2">
                <div className="c2-left">
                    <p className="p01">69 Sports</p>
                    <p className="p02">Ứng dụng tin tức thể thao hàng đầu</p>
                    <p className="p03">Theo dõi kết quả trực tiếp, phân tích chuyên sâu và cập nhật tin tức thể thao mới
                        nhất mọi lúc,
                        mọi nơi.</p>
                    <a href={downloadUrl} id="download" className="alink" target="_blank"
                       data-replace-href={downloadUrl} onFocus={()=>focusDownload()} onClick={()=>{download();}}>
                    <div className="ladi-button" id="app_download" >
                        <p className="p4-text">
                            Tải App ngay!
                        </p>
                    </div>
                    </a>
                    <div className="down-img">
                        <img src={apple} className="apple" alt={""}/>
                        <img src={googleplay} className="google-play" alt={""}/>
                    </div>
                </div>
                <div className="c2-right">
                    <img src={large} className="w1" alt={""}/>
                    <img src={small} className="w2" alt={""}/>
                </div>
            </div>
            <div className="button-layout">
                <div className="button-text-01">
                    Liên Hệ Chúng Tôi Tại
                </div>
                <div className="button-share">
                    <img src={share}  alt={""}/>
                </div>
                <div className="button-layout-01">
                <div className="button-text-02">
                    Điều khoản sử dụng  |  Chính sách bảo mật
                </div>
                <div className="button-text-03">
                    2022 All Rights Reserved © 69sport
                </div>
                </div>
            </div>
        </div>
    );
}

export default App;

